import Popup from "../../lib/Popup";

import * as PIXI from "pixi.js";
import gsap from "gsap";
import { IGameSnacks } from "../../lib/GameSnacks";
import ServiceLocator from "../../ServiceLocator";
import Utils from "../../Utils";
import Button from "../../lib/Button";
import { Profile } from "../../lib/game_snacks/IUser";
import Session from "../../Session";
import PlayerSlot from "./PlayerSlot";
import ShopItem, { shop_item_state, shop_item_type } from "../shop/ShopItem";
import SpriteMaskAnim from "../../lib/SpriteMaskAnim";

declare global {
    interface Window { GameSnacks: IGameSnacks; }
}


export default class LevelUpPopup extends Popup
{
    // #region Attributes //

    // private:

    private _coinBalance: PIXI.Text = null;
    private _bannerMaskIn: SpriteMaskAnim = null;
    private _baseAnim: PIXI.AnimatedSprite = null;
    private _playerSlotAnim: PIXI.AnimatedSprite = null;
    private _winnerFrameAnim: PIXI.AnimatedSprite = null;
    private _rewardValue: PIXI.Text = null;
    private _smallCoinIcon: PIXI.Sprite = null;
    private _okBtn: Button = null;

    private _introLayer: PIXI.Container = null;
    private _playerSlotLayer: PIXI.Container = null;
    private _introEndLayer: PIXI.Container = null;

    private _reward: number = null;

    private _sprayHowl: Howl = null;

    // #endregion //


    // #region Methods //

    // public:

    public onEnter(): void
    {
        super.onEnter( { bgAlpha: 0.9 } );  

        this._reward = ServiceLocator.resources.game_config.data.rewards.levelUp.coins;

        this._introLayer = new PIXI.Container();
        this._root.addChild( this._introLayer );
        //        
        this._playerSlotLayer = new PIXI.Container();
        this._playerSlotLayer.visible = false;
        this._root.addChild( this._playerSlotLayer );
        //
        this._introEndLayer = new PIXI.Container();
        this._introEndLayer.visible = false;
        this._root.addChild( this._introEndLayer );

        let coinIcon: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.icon_coin.texture );
        coinIcon.anchor.set( 0.5 );
        coinIcon.position.set( 460, 39 );
        this._root.addChild( coinIcon );

        this._coinBalance = new PIXI.Text( ServiceLocator.saved.data.coins.toString(), {
            fontSize: 60,
            fontFamily: "jaro_regular", 
            fill: 0xffffff
            /*fill: 0x192f62, 
            stroke: 0xffffff, 
            strokeThickness: 4,
            lineJoin: "round"*/
        } );
        this._coinBalance.anchor.set( 1, 0.5 );
        this._coinBalance.position.set( 612, coinIcon.y );
        this._root.addChild( this._coinBalance );   
        Utils.fitTextToWidth( this._coinBalance, 116 );

        let bannerWrapper: PIXI.Container = new PIXI.Container();
        bannerWrapper.visible = false;
        bannerWrapper.position.set( ServiceLocator.app.width * 0.5, 174 );
        this._introLayer.addChild( bannerWrapper );
        //
        let bannerBg: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.win_level_label.texture );
        bannerBg.anchor.set( 0.5 );
        bannerWrapper.addChild( bannerBg );
        //
        let bannerMessage: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.level_up.texture );
        bannerMessage.anchor.set( 0.5 );
        bannerWrapper.addChild( bannerMessage );

        this._bannerMaskIn = new SpriteMaskAnim( Utils.createTexArray( "hud_mask_banner_in_", 7 ) );
        this._bannerMaskIn.fps = 30;
        this._bannerMaskIn.init();
        this._bannerMaskIn.visible = false;
        this._bannerMaskIn.anchor.set( 0.5 );
        this._bannerMaskIn.position.copyFrom( bannerWrapper );
        this._introLayer.addChild( this._bannerMaskIn );
        //
        bannerWrapper.mask = this._bannerMaskIn;

        this._baseAnim = new PIXI.AnimatedSprite( Utils.createTexArray( "go_vfx_win_base_", 3 ) );
        this._baseAnim.animationSpeed = 10;
        this._baseAnim.loop = false;
        this._baseAnim.autoUpdate = false;
        this._baseAnim.anchor.set( 0.5 );
        this._baseAnim.position.set( 318, 606 );
        this._introLayer.addChild( this._baseAnim );

        let arrShopUnlockedItem: Array<number> = Utils.findShopUnlockedItems( ServiceLocator.saved.data.level );
        if ( arrShopUnlockedItem[ 0 ] !== null || arrShopUnlockedItem[ 1 ] !== null )
        {
            let shopText = new PIXI.Text( "New items availale\nin the Shop!", { fontFamily: "jaro_regular", fontSize: 30, fill: 0xffffff, align: "center" } );
            shopText.anchor.set( 0.5 );
            shopText.position.set( ServiceLocator.app.width * 0.5, 740 );
            this._introEndLayer.addChild( shopText );
            //
            let shopIcon: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.lobby_button_shop.texture );
            shopIcon.scale.set( 96 / shopIcon.texture.width );
            shopIcon.anchor.set( 0.5 );
            shopIcon.position.set( 508, 728 );
            this._introEndLayer.addChild( shopIcon ); 
            //
            let exclamationIcon: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.lobby_icon_exclamation.texture );
            exclamationIcon.scale.set( 44 / exclamationIcon.texture.width );
            exclamationIcon.anchor.set( 0.5 );
            exclamationIcon.position.set( 522 + 14, 698 - 8 );
            this._introEndLayer.addChild( exclamationIcon );
        }
        else
        {
            let playerSlot: PlayerSlot = new PlayerSlot( ServiceLocator.resources.avatar_level_up_base.texture );
            playerSlot.setPlayer( Session.i.profile );
            playerSlot.position.set( ServiceLocator.app.width * 0.5, 514 );
            this._playerSlotLayer.addChild( playerSlot );   

            this._playerSlotAnim = new PIXI.AnimatedSprite( Utils.createTexArray( "go_vfx_profile_", 4 ) );
            this._playerSlotAnim.visible = false;
            this._playerSlotAnim.animationSpeed = 10;
            this._playerSlotAnim.loop = false;
            this._playerSlotAnim.autoUpdate = false;
            this._playerSlotAnim.anchor.set( 0.5 );
            this._playerSlotAnim.position.copyFrom( playerSlot.position );
            this._introLayer.addChild( this._playerSlotAnim );

            this._winnerFrameAnim = new PIXI.AnimatedSprite( Utils.createTexArray( "go_vfx_win_frame_", 3 ) );
            this._winnerFrameAnim.visible = false;
            this._winnerFrameAnim.animationSpeed = 10;
            this._winnerFrameAnim.loop = false;
            this._winnerFrameAnim.autoUpdate = false;
            this._winnerFrameAnim.anchor.set( 0.5 );
            this._winnerFrameAnim.position.copyFrom( playerSlot.position );
            this._playerSlotLayer.addChild( this._winnerFrameAnim );

            let levelBase: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.go_level_base.texture );
            levelBase.scale.set( 0.8 );
            levelBase.anchor.set( 0.5 );
            levelBase.position.set( 473 - 60, 745 - 140 )
            this._playerSlotLayer.addChild( levelBase );     
            //
            let levelText: PIXI.Text = new PIXI.Text( ServiceLocator.saved.data.level.toString(), { fontSize: 60, fontFamily: "college_tm_regular", fill: 0x192f62, stroke: 0xffffff, strokeThickness: 4, lineJoin: "round" } );
            levelText.anchor.set( 0.5 );
            levelText.y = 2;
            levelBase.addChild( levelText );   
        }

        let rewardBase: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.reward_label.texture );
        rewardBase.anchor.set( 0.5 );
        rewardBase.position.set( 314, 825 );
        this._introEndLayer.addChild( rewardBase );
        //
        let rewardTitle = new PIXI.Text( "Reward:", { fontFamily: "jaro_regular", fontSize: 40, fill: 0xffffff } );
        rewardTitle.anchor.set( 0, 0.5 );
        rewardTitle.position.set( 161, 825 - 4 );
        this._introEndLayer.addChild( rewardTitle );
        //
        this._rewardValue = new PIXI.Text( this._reward.toString(), { fontFamily: "jaro_regular", fontSize: 44, fill: 0xffffff } );
        this._rewardValue.anchor.set( 1, 0.5 );
        this._rewardValue.position.set( 473, rewardTitle.y + 2 );
        this._introEndLayer.addChild( this._rewardValue );
        //
        this._smallCoinIcon = new PIXI.Sprite( ServiceLocator.resources.icon_coin.texture );
        this._smallCoinIcon.anchor.set( 0.5 );
        this._smallCoinIcon.scale.set( 36 / this._smallCoinIcon.texture.width );
        this._smallCoinIcon.position.set( this._rewardValue.x - this._rewardValue.width - 6 - 18, this._rewardValue.y );
        this._introEndLayer.addChild( this._smallCoinIcon );

        this._okBtn = new Button( { on: "go_button_ok", pressed: "go_button_ok_pressed" } );
        this._okBtn.anchor.set( 0.5 );
        this._okBtn.position.set( ServiceLocator.app.width * 0.5, 1009 );
        this._introEndLayer.addChild( this._okBtn );
        this._okBtn.on( "pointertap", this._onOkBtn_Click.bind( this ) );
        
        // Start intro animation.
        if ( arrShopUnlockedItem[ 0 ] !== null || arrShopUnlockedItem[ 1 ] !== null )
        {
            this._baseAnim.onComplete = () => {
                bannerWrapper.visible = true;
                this._bannerMaskIn.visible = true;

                this._playerSlotLayer.visible = true;

                if ( arrShopUnlockedItem[ 0 ] !== null )
                {
                    let dartIndex: number = 0;
                    for ( let dartInfo of ServiceLocator.resources.game_config.data.darts )
                    {
                        if ( ServiceLocator.saved.data.level == dartInfo.unlockLevel )
                        {
                            break;
                        }
                        else if ( dartInfo.unlockLevel > ServiceLocator.saved.data.level )
                        {
                            break;
                        }

                        dartIndex += 1;
                    }

                    let dartItem: ShopItem = new ShopItem();
                    dartItem.type = shop_item_type.DART;
                    dartItem.state = shop_item_state.ANNOUNCED;
                    dartItem.index = dartIndex;
                    dartItem.init();
                    dartItem.position.set( ServiceLocator.app.width * 0.5 - dartItem.width * 0.5, 514 - dartItem.height * 0.5 );
                    this._playerSlotLayer.addChild( dartItem );
                }
                else if ( arrShopUnlockedItem[ 1 ] !== null )
                {
                    let boardIndex: number = 0;
                    for ( let boardInfo of ServiceLocator.resources.game_config.data.boards )
                    {
                        if ( ServiceLocator.saved.data.level == boardInfo.unlockLevel )
                        {
                            break;
                        }
                        else if ( boardInfo.unlockLevel > ServiceLocator.saved.data.level )
                        {
                            break;
                        }

                        boardIndex += 1;
                    }

                    let boardItem: ShopItem = new ShopItem();
                    boardItem.type = shop_item_type.BOARD;
                    boardItem.state = shop_item_state.ANNOUNCED;
                    boardItem.index = boardIndex;
                    boardItem.init();
                    boardItem.position.set( ServiceLocator.app.width * 0.5 - boardItem.width * 0.5, 514 - boardItem.height * 0.5 );
                    this._playerSlotLayer.addChild( boardItem );
                }
                
                this._sprayHowl.stop();
                this._sprayHowl = ServiceLocator.audio.playSfx( "intro_spray_2", { loop: true } );
            };
        }
        else
        {
            this._baseAnim.onComplete = () => {
                this._playerSlotAnim.visible = true;
                this._playerSlotAnim.play();

                this._sprayHowl.stop();
                this._sprayHowl = ServiceLocator.audio.playSfx( "intro_spray_1", { loop: true } );
            };
            //
            this._playerSlotAnim.onComplete = () => {
                this._playerSlotAnim.visible = false;

                this._playerSlotLayer.visible = true;

                this._winnerFrameAnim.visible = true;
                this._winnerFrameAnim.play();
            };
            //
            this._winnerFrameAnim.onComplete = () => {
                bannerWrapper.visible = true;
                this._bannerMaskIn.visible = true;
                
                this._sprayHowl.stop();
                this._sprayHowl = ServiceLocator.audio.playSfx( "intro_spray_2", { loop: true } );
            };
        }
        //
        this._bannerMaskIn.onCompleted.addOnce( () => {
            this._bannerMaskIn.visible = false;
            
            this._introEndLayer.visible = true;
            
            this._sprayHowl.stop();
            this._sprayHowl = null;

            ServiceLocator.audio.playSfx( "level_up" );
        }, this );
        //
        this._baseAnim.play();
        
        this._sprayHowl = ServiceLocator.audio.playSfx( "intro_spray_0", { loop: true } );
    }

        private _onOkBtn_Click(): void
        {
            this._onClosed.dispatch();
        }

    public onUpdate( dt: number ): void
    {
        if ( this._baseAnim.visible )
        {
            this._baseAnim.update( dt );
        }
        if ( this._bannerMaskIn.visible )
        {
            this._bannerMaskIn.update( dt );
        }
        if ( this._playerSlotAnim && this._playerSlotAnim.visible )
        {
            this._playerSlotAnim.update( dt );
        }
        if ( this._winnerFrameAnim && this._winnerFrameAnim.visible )
        {
            this._winnerFrameAnim.update( dt );
        }
    }

    // #endregion //
}